export default {
  title: 'Últimas 4 semanas',
  item_interval: '(1)[1 visita];(2)[2 visitas];(3-5)[3-5 visitas];(6-inf)[6+ visitas];',
  total: 'Total de Visitantes',
};
